import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

export const SWIPER_MODULE = {
    NAVIGATION: Navigation,
    PAGINATION: Pagination,
    SCROLLBAR: Scrollbar
};

export const setSwiper = (el = null, options = {}) => {
    if(!el || !options) {
        console.error('Swiper를 생성하기 위한 값이 존재하지 않습니다.');
        return;
    }

    return new Swiper(el, options);
};